import React from "react";
import PublicLayout from "../components/PublicLayout";
import { useT } from "../lib/i18n";

export default function About() {
  const t = useT();
  return (
    <PublicLayout>
      <section className="max-w-4xl mx-auto px-4 pt-10 pb-16">
        <div className="text-xs uppercase tracking-widest text-[#ea580c] font-semibold">{t("about.eyebrow")}</div>
        <h1 className="text-4xl sm:text-5xl font-display font-black tracking-tight">{t("about.title")}</h1>
        <p className="text-slate-600 mt-6 leading-relaxed">{t("about.body")}</p>
        <div className="grid md:grid-cols-3 gap-6 mt-10">
          <div className="p-6 rounded-xl bg-white border border-slate-200"><div className="text-3xl font-display font-black text-[#ea580c]">15+</div><div className="text-sm text-slate-500 mt-1">{t("about.years")}</div></div>
          <div className="p-6 rounded-xl bg-white border border-slate-200"><div className="text-3xl font-display font-black text-[#ea580c]">30+</div><div className="text-sm text-slate-500 mt-1">{t("about.fleet_size")}</div></div>
          <div className="p-6 rounded-xl bg-white border border-slate-200"><div className="text-3xl font-display font-black text-[#ea580c]">10K+</div><div className="text-sm text-slate-500 mt-1">{t("about.happy")}</div></div>
        </div>
      </section>
    </PublicLayout>
  );
}
